<template>
  <div class="bottomnav-shell">
    <router-link to="/home" class="nav-item" :class="{ active: isActive('/home') }">Home</router-link>
    <router-link to="/trade" class="nav-item" :class="{ active: isActive('/trade') }">Trade</router-link>
    <router-link to="/claim" class="nav-item" :class="{ active: isActive('/claim') }">Claim</router-link>
    <router-link to="/wallet" class="nav-item" :class="{ active: isActive('/wallet') }">Wallet</router-link>
  </div>
</template>

<script>
export default {
  name: 'BottomNav',
  methods: { isActive(path) { return this.$route.path === path } }
}
</script>

<style scoped>
.bottomnav-shell {
  position: fixed; left: 0; right: 0; bottom: 0; z-index: 9999;
  display: flex; justify-content: space-around; align-items: center;
  height: 72px; padding-bottom: env(safe-area-inset-bottom);
  background: rgba(10,10,15,.92);
  backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255,255,255,.06);
}
.nav-item {
  display: flex; align-items: center; justify-content: center;
  flex: 1; height: 100%;
  color: var(--text-dim);
  text-decoration: none;
  font-size: var(--font-size-base); font-weight: 600;
  transition: all var(--duration-fast) var(--ease-out);
}
.nav-item.active {
  color: var(--accent);
  text-shadow: 0 0 18px rgba(92,94,220,.6);
}
</style>
